"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLMenuElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLMenuElementImpl, _HTMLElementImpl);

  function HTMLMenuElementImpl() {
    _classCallCheck(this, HTMLMenuElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLMenuElementImpl).apply(this, arguments));
  }

  return HTMLMenuElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLMenuElementImpl
};